module.exports = __webpack_public_path__ + "img/icon_site_search_active.33708530.png";